const CHECK_ICON = (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5"
        strokeLinecap="round" strokeLinejoin="round">
        <polyline points="20 6 9 17 4 12" />
    </svg>
);

const STEPS = [
    { id: 1, label: 'Choose Family',   description: 'RTD or Concentrate' },
    { id: 2, label: 'Select Format',   description: 'Bottle, can or keg'  },
    { id: 3, label: 'Set Quantity',    description: 'Kegs or target units' },
    { id: 4, label: 'Review & Create', description: 'Confirm and create'  },
];

const StepProgressBar = ({ currentStep, completedSteps, onStepClick, maxStepRevealed }) => {
    return (
        <div className="gsp-progress-bar">
            {STEPS.map((step, index) => {
                const isCompleted = completedSteps.includes(step.id);
                const isCurrent   = currentStep === step.id;
                const isClickable = step.id === 1 || completedSteps.includes(step.id - 1) || step.id <= maxStepRevealed;

                const dotState  = isCurrent ? 'current' : isCompleted ? 'completed' : 'upcoming';
                const itemState = isCurrent ? 'current' : isCompleted ? 'completed' : '';

                return (
                    <div key={step.id} className="gsp-step-wrapper">
                        <button
                            className={`gsp-step-item ${itemState}`}
                            onClick={() => isClickable && onStepClick(step.id)}
                            disabled={!isClickable}
                            aria-current={isCurrent ? 'step' : undefined}
                        >
                            <div className={`gsp-step-dot ${dotState}`}>
                                {isCompleted ? CHECK_ICON : <span>{step.id}</span>}
                            </div>
                            <div className="gsp-step-text">
                                <span className="gsp-step-label">{step.label}</span>
                                <span className="gsp-step-desc">{step.description}</span>
                            </div>
                        </button>

                        {index < STEPS.length - 1 && (
                            <div className={`gsp-step-connector ${isCompleted ? 'completed' : ''}`} />
                        )}
                    </div>
                );
            })}
        </div>
    );
};

export default StepProgressBar;
